import {ANALYTICS_ENABLED} from '../../configs/vars';
import {AddAnalyticEventDocument, AnalyticEventType} from '../../graphql-types';
import graphQLClient from '../graphql/client';

const logClick = (value: string, data: JSONValue): void => {
    if (!ANALYTICS_ENABLED || !localStorage?.accountState) {
        return;
    }

    try {
        const pageUrl = window.location.pathname;
        const analyticsData = {
            type: AnalyticEventType.Click,
            value,
            pageUrl,
            data,
        };

        graphQLClient.mutate({
            mutation: AddAnalyticEventDocument,
            variables: {
                input: analyticsData,
            },
        }).then(() => { }).catch(() => { });
    } catch (e) {}
};

export default logClick;
